import React, { ChangeEvent } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";

interface IInput {
  type: string;
  placeholder: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

function Input({ type, placeholder, onChange, value }: IInput) {
  return (
    <InputStyle
      type={type}
      placeholder={placeholder}
      autoComplete="new-password"
      value={value}
      onChange={(e) => onChange(e)}
    />
  );
}

const InputStyle = styled.input`
  border: 0;
  border: 1px solid ${colors.Gray30};
  height: 50px;
  width: 100%;
  border-radius: 10px;
  padding: 0 20px;

  &:focus,
  &:focus-visible {
    outline: 0;
  }
`;

export default Input;
